import React, { useEffect } from "react"
import { Button, Card, Popconfirm, Tree } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { useDictModel } from "../dictModel"
import { IDictDetail, OptType } from "../dictTypes"
import { globalPrompt } from "../../../../components2/YhMessage"

function containsChildByKey(node: IDictDetail, key: React.Key): any {
    if (node.hasOwnProperty("children")) {
        for (let childNode of node.children as IDictDetail[]) {
            if (childNode) {
                if (childNode.key === key) {
                    return node;
                }
                const ret = containsChildByKey(childNode, key);
                if (ret != null) {
                    return ret;
                }
            }
        }
    }
}

function getPNodeByKey(key: React.Key, initTreeData: IDictDetail[]) {
    for (let node of initTreeData) {
        const pNode = containsChildByKey(node, key)
        if (pNode != null) {
            return pNode;
        }
    }
}

const DictTree = () => {
    const { dictData, selectDictPRow, selectDictRow, selectDictRowKey, root, setOptType, setRoot, setAddTreeFrom,removeTreeForm, loadDictData, setSelectDictRowKey, setSelectDictRow, setSelectDictPRow,} = useDictModel()
    useEffect(() => {
        loadDictData()
    }, [])
    const addPeer = () => {
        let rowCode = selectDictRow.code as string
        let rowCodeSlice = rowCode.slice(0, rowCode.length - 1)
        let pcodeLen = selectDictPRow?.children?.length as number
        if (selectDictPRow) {
            setAddTreeFrom({
                pcode: selectDictRow.pcode,
                code: rowCodeSlice + (pcodeLen + 1),
                branch:selectDictRow.branch
            })
            setRoot(true)
        } else {//当前选中为根级元素的时候，他的字典编码是可以自定义编辑的
            setRoot(false)
            setAddTreeFrom({})
        }
        setOptType(OptType.ADD_SAME_LEVEL);

    }
    const addSon = () => {
        const { children, code } = selectDictRow
        let dictRowLen = children?.length as number
        setAddTreeFrom({
            pcode: code,
            code: `${code}-0${dictRowLen >= 10 ? dictRowLen + 1 : '0' + (dictRowLen + 1)}`,
            branch:selectDictRow.branch
        })
        setRoot(true)
        setOptType(OptType.ADD_CHILD_LEVEL);
    }
    const remove = ()=>{
        if(selectDictRowKey.length==0){
            return globalPrompt("message",{type:"error",text:"请先选择要删除的值"})
        }
        removeTreeForm()
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={selectDictRowKey.length==0}
            onClick={() => addPeer()}
        >增加同级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={selectDictRowKey.length==0}
            onClick={() => addSon()}
        >增加下级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={true}
            onClick={() => remove()}
        >删除</Button>
    </>
    const onSelect = (selectedKeys: React.Key[], info: any) => {
        const selectedNode = info.selectedNodes[0];
        const pNode = getPNodeByKey(selectedKeys[0], dictData)
        setRoot(true)
        setSelectDictPRow(pNode)
        setSelectDictRow(selectedNode)
        setSelectDictRowKey(selectedKeys)
        setOptType(OptType.DETAIL)
    }
    const onCheck = () => {

    }
    return <YhBox action={action} title="字典目录" width="500px" maxHeight="650px">
        <Tree
            className="p-15"
            treeData={dictData}
            selectedKeys={selectDictRowKey}
            // titleRender={(node: any) => `${node.name}`}
            onSelect={onSelect}
            onCheck={onCheck}
        />
    </YhBox>
}
export default DictTree